import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import { ROUTES } from '@/routes/routes';

const ROLE_DASHBOARD: Record<string, string> = {
  owner: ROUTES.DASHBOARD_OWNER,
  admin: ROUTES.DASHBOARD_ADMIN,
  'operations-user': ROUTES.DASHBOARD_OPERATIONS,
  'commercial-user': ROUTES.DASHBOARD_COMMERCIAL,
  'service-engineer': ROUTES.DASHBOARD_ENGINEER,
  'master-service-engineer': ROUTES.DASHBOARD_MASTER_ENGINEER,
};

export function DashboardPage() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    const roleSlug = user?.roleSlug ?? null;
    const target = roleSlug
      ? (ROLE_DASHBOARD[roleSlug] ?? ROUTES.DASHBOARD_ADMIN)
      : ROUTES.DASHBOARD_ADMIN;
    navigate(target, { replace: true });
  }, [user, navigate]);

  return null;
}
